import React, { useCallback, useMemo } from 'react';
import { Tag } from '@meitu/saas-ui';
import './tag-menu.less';
import { BrushTagType } from '../config';
import { getTagConfig } from './tag-config';

interface IBrushTag {
    type: BrushTagType;
    name: string;
}

interface TagMenuProps {
    selectedValue?: BrushTagType;
    onChange?: (item: BrushTagType) => void;
}

const { CheckableTag } = Tag;

const TagMenu: React.FC<TagMenuProps> = ({ selectedValue = BrushTagType.all, onChange }) => {
    const tagsViewList = useMemo(() => {
        return getTagConfig();
    }, []);

    const onChangeHandle = useCallback((item: IBrushTag, e: boolean) => {
        if (e) {
            onChange?.(item.type);
        }
    }, []);

    return (
        <div className="brush-tag-menu-wrap">
            <ul className="tag-item-list">
                {tagsViewList.map((item) => (
                    <li className="tag-item" key={item.type}>
                        <CheckableTag checked={item.type === selectedValue} onChange={(e) => onChangeHandle(item, e)}>
                            {item.name}
                        </CheckableTag>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default React.memo(TagMenu);
